// Base style overrides
import { colors } from "./colors";
import { sizes } from "./sizes";
import { space } from "./spacing";
import { fonts, fontSizes, fontWeights, lineHeights } from "./fonts";
import { radii } from "./radii";
import { textStyles } from "./textStyles";
import { shadows } from "./shadows";
import { borderWidths } from "./borders";
import { semanticTokens } from "./semanticTokens";
import { globalStyles as styles } from "./globalStyles";
export var base = {
    styles: styles,
    semanticTokens: semanticTokens,
    colors: colors,
    sizes: sizes,
    borderWidths: borderWidths,
    radii: radii,
    space: space,
    fonts: fonts,
    fontSizes: fontSizes,
    lineHeights: lineHeights,
    fontWeights: fontWeights,
    textStyles: textStyles,
    shadows: shadows,
};
